"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderImageOrLottieAnimation = void 0;
var _react = _interopRequireDefault(require("react"));
var _FocusedImage = _interopRequireDefault(require("../jscomponents/FocusedImage/FocusedImage"));
var _LottieAnimation = _interopRequireDefault(require("../jscomponents/LottieAnimation/LottieAnimation"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const renderImageOrLottieAnimation = function (image, focusedImageStyles, focusedImageSizes, focusedImageAlt, elementClass, lottieStyles) {
  let fullHeightWrapper = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
  let lottieRatio = arguments.length > 7 ? arguments[7] : undefined;
  let lazyLoad = arguments.length > 8 ? arguments[8] : undefined;
  if (image?.type === "lottieAnimation") {
    const animationRatio = lottieRatio ? lottieRatio : image?.ratio;
    return /*#__PURE__*/_react.default.createElement(_LottieAnimation.default, {
      contentfulId: image?.contentfulId ? image?.contentfulId : null,
      src: image?.src,
      style: {
        ...image?.style,
        ...lottieStyles
      },
      className: elementClass,
      ratio: {
        ...animationRatio
      }
    });
  } else {
    return /*#__PURE__*/_react.default.createElement(_FocusedImage.default, {
      contentfulId: image?.contentfulId ? image?.contentfulId : null,
      fullHeightWrapper: fullHeightWrapper,
      focalPointImage: image?.focalPointImage || image,
      pictureStyles: focusedImageStyles,
      imageSizes: focusedImageSizes,
      alt: focusedImageAlt,
      className: elementClass,
      lazyLoad: lazyLoad
    });
  }
};
exports.renderImageOrLottieAnimation = renderImageOrLottieAnimation;